import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Basic List"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview-tab",
              tabindex: "0"
            }, [
              _createElementVNode("ul", { class: "list-group" }, [
                _createElementVNode("li", { class: "list-group-item bg-white" }, "An item"),
                _createElementVNode("li", { class: "list-group-item bg-white" }, "A second item"),
                _createElementVNode("li", { class: "list-group-item bg-white" }, "A third item"),
                _createElementVNode("li", { class: "list-group-item bg-white" }, "A fourth item"),
                _createElementVNode("li", { class: "list-group-item bg-white" }, "And a fifth one")
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode"
                }, "\n<ul class=\"list-group\">\n<li class=\"list-group-item bg-white\">An item</li>\n<li class=\"list-group-item bg-white\">A second item</li>\n<li class=\"list-group-item bg-white\">A third item</li>\n<li class=\"list-group-item bg-white\">A fourth item</li>\n<li class=\"list-group-item bg-white\">And a fifth one</li>\n</ul>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Active List"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab2",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview2-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code2-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent2"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("ul", { class: "list-group" }, [
                _createElementVNode("li", {
                  class: "list-group-item active",
                  "aria-current": "true"
                }, " An active item "),
                _createElementVNode("li", { class: "list-group-item bg-white" }, "A second item"),
                _createElementVNode("li", { class: "list-group-item bg-white" }, "A third item"),
                _createElementVNode("li", { class: "list-group-item bg-white" }, "A fourth item"),
                _createElementVNode("li", { class: "list-group-item bg-white" }, "And a fifth one")
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode2"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode2"
                }, "\n<ul class=\"list-group\">\n<li class=\"list-group-item active\" aria-current=\"true\">An active item</li>\n<li class=\"list-group-item bg-white\">A second item</li>\n<li class=\"list-group-item bg-white\">A third item</li>\n<li class=\"list-group-item bg-white\">A fourth item</li>\n<li class=\"list-group-item bg-white\">And a fifth one</li>\n</ul>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Numbered List"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab3",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview3-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code3-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent3"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("ol", { class: "list-group list-group-numbered" }, [
                _createElementVNode("li", { class: "list-group-item bg-white d-flex justify-content-between align-items-start" }, [
                  _createElementVNode("div", { class: "ms-2 me-auto" }, [
                    _createElementVNode("div", { class: "fw-bold" }, "Subheading"),
                    _createTextVNode(" Content for list item ")
                  ]),
                  _createElementVNode("span", { class: "badge bg-primary rounded-pill" }, "14")
                ]),
                _createElementVNode("li", { class: "list-group-item bg-white d-flex justify-content-between align-items-start" }, [
                  _createElementVNode("div", { class: "ms-2 me-auto" }, [
                    _createElementVNode("div", { class: "fw-bold" }, "Subheading"),
                    _createTextVNode(" Content for list item ")
                  ]),
                  _createElementVNode("span", { class: "badge bg-primary rounded-pill" }, "14")
                ]),
                _createElementVNode("li", { class: "list-group-item bg-white d-flex justify-content-between align-items-start" }, [
                  _createElementVNode("div", { class: "ms-2 me-auto" }, [
                    _createElementVNode("div", { class: "fw-bold" }, "Subheading"),
                    _createTextVNode(" Content for list item ")
                  ]),
                  _createElementVNode("span", { class: "badge bg-primary rounded-pill" }, "14")
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode3"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode3"
                }, "\n<ol class=\"list-group list-group-numbered\">\n<li class=\"list-group-item bg-white d-flex justify-content-between align-items-start\">\n<div class=\"ms-2 me-auto\">\n<div class=\"fw-bold\">Subheading</div>\nContent for list item\n</div>\n<span class=\"badge bg-primary rounded-pill\">14</span>\n</li>\n<li class=\"list-group-item bg-white d-flex justify-content-between align-items-start\">\n<div class=\"ms-2 me-auto\">\n<div class=\"fw-bold\">Subheading</div>\nContent for list item\n</div>\n<span class=\"badge bg-primary rounded-pill\">14</span>\n</li>\n<li class=\"list-group-item bg-white d-flex justify-content-between align-items-start\">\n<div class=\"ms-2 me-auto\">\n<div class=\"fw-bold\">Subheading</div>\nContent for list item\n</div>\n<span class=\"badge bg-primary rounded-pill\">14</span>\n</li>\n</ol>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Variants List"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab4",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview4-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code4-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent4"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("ul", { class: "list-group" }, [
                _createElementVNode("li", { class: "list-group-item" }, " A simple default list group item "),
                _createElementVNode("li", { class: "list-group-item list-group-item-primary" }, " A simple primary list group item "),
                _createElementVNode("li", { class: "list-group-item list-group-item-secondary" }, " A simple secondary list group item "),
                _createElementVNode("li", { class: "list-group-item list-group-item-success" }, " A simple success list group item "),
                _createElementVNode("li", { class: "list-group-item list-group-item-danger" }, " A simple danger list group item "),
                _createElementVNode("li", { class: "list-group-item list-group-item-warning" }, " A simple warning list group item "),
                _createElementVNode("li", { class: "list-group-item list-group-item-info" }, " A simple info list group item "),
                _createElementVNode("li", { class: "list-group-item list-group-item-light" }, " A simple light list group item "),
                _createElementVNode("li", { class: "list-group-item list-group-item-dark" }, " A simple dark list group item ")
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode4"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode4"
                }, "\n<ul class=\"list-group\">\n<li class=\"list-group-item\">A simple default list group item</li>\n<li class=\"list-group-item list-group-item-primary\">A simple primary list group item</li>\n<li class=\"list-group-item list-group-item-secondary\">A simple secondary list group item</li>\n<li class=\"list-group-item list-group-item-success\">A simple success list group item</li>\n<li class=\"list-group-item list-group-item-danger\">A simple danger list group item</li>\n<li class=\"list-group-item list-group-item-warning\">A simple warning list group item</li>\n<li class=\"list-group-item list-group-item-info\">A simple info list group item</li>\n<li class=\"list-group-item list-group-item-light\">A simple light list group item</li>\n<li class=\"list-group-item list-group-item-dark\">A simple dark list group item</li>\n</ul>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Custom content"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab5",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview5-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code5-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent5"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "list-group" }, [
                _createElementVNode("a", {
                  href: "#",
                  class: "list-group-item list-group-item-action active",
                  "aria-current": "true"
                }, [
                  _createElementVNode("div", { class: "d-flex w-100 justify-content-between" }, [
                    _createElementVNode("h5", { class: "mb-1" }, "List group item heading"),
                    _createElementVNode("small", null, "3 days ago")
                  ]),
                  _createElementVNode("p", { class: "mb-1" }, "Some placeholder content in a paragraph."),
                  _createElementVNode("small", null, "And some small print.")
                ]),
                _createElementVNode("a", {
                  href: "#",
                  class: "list-group-item list-group-item-action"
                }, [
                  _createElementVNode("div", { class: "d-flex w-100 justify-content-between" }, [
                    _createElementVNode("h5", { class: "mb-1" }, "List group item heading"),
                    _createElementVNode("small", { class: "text-body-secondary" }, "3 days ago")
                  ]),
                  _createElementVNode("p", { class: "mb-1" }, "Some placeholder content in a paragraph."),
                  _createElementVNode("small", { class: "text-body-secondary" }, "And some muted small print.")
                ]),
                _createElementVNode("a", {
                  href: "#",
                  class: "list-group-item list-group-item-action"
                }, [
                  _createElementVNode("div", { class: "d-flex w-100 justify-content-between" }, [
                    _createElementVNode("h5", { class: "mb-1" }, "List group item heading"),
                    _createElementVNode("small", { class: "text-body-secondary" }, "3 days ago")
                  ]),
                  _createElementVNode("p", { class: "mb-1" }, "Some placeholder content in a paragraph."),
                  _createElementVNode("small", { class: "text-body-secondary" }, "And some muted small print.")
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode5"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode5"
                }, "\n<div class=\"list-group\">\n<a href=\"#\" class=\"list-group-item list-group-item-action active\" aria-current=\"true\">\n<div class=\"d-flex w-100 justify-content-between\">\n<h5 class=\"mb-1\">List group item heading</h5>\n<small>3 days ago</small>\n</div>\n<p class=\"mb-1\">Some placeholder content in a paragraph.</p>\n<small>And some small print.</small>\n</a>\n<a href=\"#\" class=\"list-group-item list-group-item-action\">\n<div class=\"d-flex w-100 justify-content-between\">\n<h5 class=\"mb-1\">List group item heading</h5>\n<small class=\"text-body-secondary\">3 days ago</small>\n</div>\n<p class=\"mb-1\">Some placeholder content in a paragraph.</p>\n<small class=\"text-body-secondary\">And some muted small print.</small>\n</a>\n<a href=\"#\" class=\"list-group-item list-group-item-action\">\n<div class=\"d-flex w-100 justify-content-between\">\n<h5 class=\"mb-1\">List group item heading</h5>\n<small class=\"text-body-secondary\">3 days ago</small>\n</div>\n<p class=\"mb-1\">Some placeholder content in a paragraph.</p>\n<small class=\"text-body-secondary\">And some muted small print.</small>\n</a>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Checkboxes and radios List"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab6",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview6-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview6-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview6-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code6-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code6-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code6-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent6"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview6-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview6-tab",
              tabindex: "0"
            }, [
              _createElementVNode("ul", { class: "list-group" }, [
                _createElementVNode("li", { class: "list-group-item bg-white" }, [
                  _createElementVNode("input", {
                    class: "form-check-input me-1",
                    type: "checkbox",
                    value: "",
                    id: "firstCheckbox"
                  }),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: "firstCheckbox"
                  }, "First checkbox")
                ]),
                _createElementVNode("li", { class: "list-group-item bg-white" }, [
                  _createElementVNode("input", {
                    class: "form-check-input me-1",
                    type: "checkbox",
                    value: "",
                    id: "secondCheckbox"
                  }),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: "secondCheckbox"
                  }, "Second checkbox")
                ]),
                _createElementVNode("li", { class: "list-group-item bg-white" }, [
                  _createElementVNode("input", {
                    class: "form-check-input me-1",
                    type: "checkbox",
                    value: "",
                    id: "thirdCheckbox"
                  }),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: "thirdCheckbox"
                  }, "Third checkbox")
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code6-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code6-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode6"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode6"
                }, "\n<ul class=\"list-group\">\n<li class=\"list-group-item bg-white\">\n<input class=\"form-check-input me-1\" type=\"checkbox\" value=\"\" id=\"firstCheckbox\">\n<label class=\"form-check-label\" for=\"firstCheckbox\">First checkbox</label>\n</li>\n<li class=\"list-group-item bg-white\">\n<input class=\"form-check-input me-1\" type=\"checkbox\" value=\"\" id=\"secondCheckbox\">\n<label class=\"form-check-label\" for=\"secondCheckbox\">Second checkbox</label>\n</li>\n<li class=\"list-group-item bg-white\">\n<input class=\"form-check-input me-1\" type=\"checkbox\" value=\"\" id=\"thirdCheckbox\">\n<label class=\"form-check-label\" for=\"thirdCheckbox\">Third checkbox</label>\n</li>\n</ul>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}